const featureFlags = {
  enableForUPlus: false,
  enableEmployeeDiscount: false,
  enableSnap: true,
  enablePartners: true,
  enablePartnersOffersV2: true,
  enableLTO: true,
  enablePreChurn: true,
  partnerPromotionBannerConfig: {
    safeway: true,
    vons: true,
    randalls: true,
    tomthumb: true,
    acmemarkets: true,
    carrsqc: true,
    jewelosco: true,
    albertsons: true,
    starmarket: true,
    shaws: true,
    pavilions: true,
    kingsfoodmarkets: true,
    haggen: true,
    andronicos: true,
    balduccis: true
  }, 
};


function generateUrlPaths(): any {
  const programPath = featureFlags.enableForUPlus ? 'foruplus' : 'freshpass';
  
  return {
    MANAGE_PLAN_PATH: `/${programPath}/manage`,
    SUBSCRIBE_PATH: `/${programPath}/manage/subscribe`,
    CHANGE_PLAN_PATH: `/${programPath}/manage/change`,
    CONFIRMATION_PATH: `/${programPath}/manage/confirmation`,
    CANCEL_PLAN_PATH: `/${programPath}/manage/cancel-plan`,
    FAQ_PATH: `/${programPath}/manage/${programPath}-faq`,
    GOV_ASSIST_PATH: `/${programPath}/manage/govassist`,
    UPDATE_PAYMENT_PATH: `/${programPath}/manage/update-payments`,
    PARTNERS_PATH: '/rewards/partners',
    EXPEDIA_REFERRER_PATH: '/rewards/partners/expedia',
    REWARDS_PARTNERS_DETAILS_PATH: '/rewards/partners/partner-detail',
    snapVerificationURL_UCA: "/customer-account/discount-programs/snap",
    SHOP_HOME_PATH: '/shop/home.html',
  };
}

const forUPlusData = {
  title: 'for U+™',
  name: 'for U Plus',
  displayName: '{Banner} for U+™',
  partnersAppNameCofig: 'Freshpass',
  code: {
    monthlySubsCode: "F9B88F7E-5F54-4536-AFC0-8B080D189CDF"
  },
  urlPath: generateUrlPaths(),
  promotionKeys: {
    discountCode: 'discountCode',
    segment: 'segment',
  },
  imageAssets: {
    subscribedPrimaryLogo: 'ocsp-web-ui/dist/assets/images/ForU+Logo.svg',
    premiumPerksLogo: 'ocsp-web-ui/dist/assets/images/JustForU_large.svg',
    couponItemLogo: 'ocsp-web-ui/dist/assets/images/ForU+Logo.svg',
    customerDetailsPrimaryLogo: 'ocsp-web-ui/dist/assets/images/ForU+Logo.svg',
  },
  snackbar: {
    discountAndActive: {
      message: "We’re sorry, this promotion is only available for new for U+™ subscribers.",
      type: "error",
      show: true,
      closeOption: true,
      from: "discountCampaignAndActiveMembership",
      timer: 5000,
      closeOnClick: true,
      theme: "black",
      topVH: "12vh",
      leftVH: "80vw",
    },
  },
  errorCode: {
    DEFAULT_NO_SUBSCRIPTION_ERROR_CODE: 'OSMS-SUBSCRIPTION-00015',
    UNKNOWN_ERROR_CODE: 'OSMS-SUBSCRIPTION-0000',
    INVALID_BANNER_CODE: 'OSMS-SUBSCRIPTION-0001',
    CARD_CANNOT_BE_ACCEPTED_CODE: 'OSMS-SUBSCRIPTION-00022',
    OFFER_NO_LONGER_AVAILABLE_CODE: 'OSMS-SUBSCRIPTION-00047',
    INVALID_REASON_CODE: 'OSMS-SUBSCRIPTION-0009',
    CANCEL_DURING_BATCH_PROCESSING_CODE: "OSMS-SUBSCRIPTION-00013",
    CANCEL_WITHIN_BUFFER_TIME_CODE: "OSMS-SUBSCRIPTION-00014",
    SERVER_ERROR_CODE: "OSMS-SUBSCRIPTION-0007",
    SUBS_PAYMENT_ERROR_CODE: "OSMS-SUBSCRIPTION-00021",
    CARD_UNACCEPTED_ERROR_CODE: "OSMS-SUBSCRIPTION-00022",
  },
  WEBSOURCE: {
    EXPEDIA: 'WEB-EXPEDIA',
  },
  errorMessages: {
    UNKNOWN_ERROR_MESSAGE: 'Unknown error. Please contact the support team for resolution.',
    INVALID_BANNER_MESSAGE: `for U+™ isn't available on {banner} yet, but it's coming soon! Stay tuned!`,
    CARD_CANNOT_BE_ACCEPTED_MESSAGE: 'Card cannot be accepted. Please confirm card details entered correctly or continue with another form of payment.',
    OFFER_NO_LONGER_AVAILABLE_MESSAGE: 'We\'re sorry, this offer is no longer available.',
    DEFAULT_ERROR_MESSAGE: 'Sorry, we\'re having technical difficulties and working on fixing them, please check back later.',
    INVALID_REASON_MESSAGE: "Cancellation reason is invalid.",
    CANCEL_DURING_BATCH_PROCESSING_MESSAGE: "Subscription is renewing and cannot be cancelled.",
    CANCEL_WITHIN_BUFFER_TIME_MESSAGE: "Your plan is currently being renewed and cannot be cancelled at this time.",
    SERVER_ERROR_MESSAGE: "Internal server error occured.",
    UNKNNOWN_ERROR_MESSAGE: "Unknown error. Please contact the support team for resolution.",
    SUBS_PAYMENT_ERROR_MESSAGE: "Your enrollment cannot be processed. Please update your payment method and try again.",
    CARD_UNACCEPTED_ERROR_MESSAGE: "Card cannot be accepted. Please confirm card details were entered correctly or continue with another form of payment",
  },
  freshpassOffers: {
    ltoTitle: "Limited time for U+™ savings",
    freshpassLTO: "FRESHPASS LTO",
    freshpassPerks: "FRESHPASS",
  },
  partnersOffers: {
    PARTNER_OFFER_TITLE_V2: "New! Exclusive partner savings",
    PARTNER_OFFER_SUBTITLE_V2: "Enjoy these benefits with your subscription.",
    PARTNER_OFFER_TITLE: "Partner offers",
    PARTNER_OFFER_SUBTITLE: "Subscribe to for U+™ and get access to these exclusive partnership benefits.",
    VALID_PARTNER_PROGRAM_TYPES: ["freshpass"],
    PARTNER_BANNER_FILTER: "partnerbanner",
  },
  notificationMsg: {
    activeEnrollmentSuccessMsg: 'for U+™ is active! Perks are on their way.',
    trialEnrollmentSuccessMsg: 'for U+™ free trial is active! Perks are on their way.',
    canceledMsg: 'Your current for U+™ plan has been cancelled effective immediately per your request.',
    cancelProcessedMsg: '{planType}: Your cancellation request has been processed',
    cancelTrialProcessedMsg: '{isTrial} - {planType}: Your cancellation request has been processed.',
    updatePlanSuccessMsg: 'Your plan has been updated successfully.',
  },
  planCard: {
    selectAction: "Select",
    SNAPAction: "See if I'm eligible",
    plusIcon: "ocsp-web-ui/dist/assets/images/plus.svg",
    moreIcon: "ocsp-web-ui/dist/assets/images/more.svg",
    greenIcon: "ocsp-web-ui/dist/assets/images/green.svg",
    checkmarkCircle: "ocsp-web-ui/dist/assets/images/checkmark-circle.svg",
    trialLabel: "-day free trial",
    creditIcon: "ocsp-web-ui/dist/assets/images/gift_Icon.svg",
    annualPlanDescription: "Which is just {monthlyPrice} + any applicable taxes. Auto-renews at {price} unless canceled by renewal date.",
    annualDiscountPlanDescription: "+Tax, Auto-renews at {renewPrice} unless canceled by renewal date.",
    monthlyPlanDescription: "Auto-renews at {price} + any applicable taxes unless canceled by renewal date.",
    SNAPPlanDescription: "Requires yearly re-verification or is automatically canceled.",
    AnnualPlan: "Annual Plan",
    MonthlyPlan: "Monthly Plan",
    SNAP: "SNAP",
    annualCreditLabel: "Monthly credit - a $60 value*",
    snapNotVerified: "Not Verified",
    planDescriptionForSNAPVerified: "Auto-renews at {pricingDetailLine1} + any applicable taxes. Requires yearly re-verification or is automatically canceled.</b>",
    monthlyPlanDescriptionForSNAPVerified: "+Tax, Auto-renews at {price}",
    annualOrmonthlySheerLabel: "Your eligibility for government assistance has been verified! Your plan will auto-renew at {price}",
    successColor: "success",
    snapBannerDescription: "Select government assistance programs get 50% off.",
    freshpassBenefitDescription: "Select government assistance programs get all the for U+™ benefits at just",
    campaignTitleText: "for U+™ benefits for half the price",
    planPerYear: "/year or ",
    planPerMonth: "/month.",
    monthlyDescriptionForSNAPVerified: "Auto-renews at {price} + any applicable taxes. Requires annual re-verification or is automatically canceled by renewal date.",
    monthlyDescriptionForSNAPVerifiedRef: "Auto-renews at {price} + any applicable taxes. Requires annual re-verification or is automatically canceled by renewal date.",
    AnnualDescriptionForSNAPVerified: "+ Any applicable taxes. Requires yearly re-verification or is automatically canceled.",
  },
  freshpassData: {
    freshpassTitle: "{banner} for U+™",
    freeTrialTitle: "Free Trial",
    freshpassManageTitle: 'Manage your {banner} for U+™ plan',
    annualPlanText: "Annual Plan",
    manageText: "manage",
    snapKey: "snap",
    forTheFirstYearText: "for the first year",
    snapVerifiedActivationMessage: "Your eligibility for government assistance has been verified! Your plan will auto-renew at ${fee}{pricingDetail} (+tax)",
    pendingActivationStatusMessage: "Your plan will auto renew at ${pendingFee}{pendingPricingDetail} after your current plan ends.",
    suspendedGovElibilityText: "Your for U+™ plan is currently suspended. Please re-verify your ",
    govAssistanceElibilityText: "government assistance eligibility.",
    pleaseReverifyEligibilityText: "Please re-verify your eligibility.",
    snapTrialDescription: "+ Any applicable taxes. Charged after {trial-duration}-day free trial. Annual re-verification will be required for continued access to discounted subscription price.",
    snapNonTrialDescription: "+ Any applicable taxes. Annual re-verification will be required for continued access to discounted subscription price.",
    fpBenefitsDescription: "Savings made simple, with free delivery, exclusive partner offers, plus all the benefits of for U™.",
    snapBottomText: "Select government programs only include SNAP.",
    snapBottomText2: "More programs coming soon!",
    lifeTimeSavingsText: "Lifetime for U+™ Savings",
    hoursSavedText: "Hours Saved",
    continueSubscription: "Continue for U+™ Subscription",
    noThanksContinueShoping: "No Thanks. Continue Shopping",
    suspendedSecondaryUserPrompt: "Your {banner} for U+™ plan is currently disabled due to an issue with your payment method. Please contact the primary for U+™ account holder to update the payment method.",
    suspendedSecondaryUserAndGovAssistancePrompt: 'Your {banner} for U+™ plan is currently disabled. Please contact the primary for U+™ account holder to re-verify their government assistance eligibility.',
    lifeTimeSavingsTooltipDisclaimer: "Total savings are calculated starting on 6/22/2022. If you subscribed to for U+™ after this date, your total savings are calculated starting on your subscription date. Total savings calculation is based on discounts to grocery delivery fees and redemption of perks listed on the for U+™ subscription page."
  },
  subscribeData: {
    step2HeaderTitle: '{Banner} for U+™ sign up',
    redirectedTo: "You will be redirected to",
    shop: "Shop",
    likeToProceed: "you like to proceed?",
    completed: "Completed",
    step: "Step",
    step1: "Step 1",
    step2: "Step 2",
    step3: "Step 3",
    currentStep: "Current step",
    agreeTo: "I agree to the",
    cancel: "Cancel",
    freshPass: "for U+™",
    zipHeading: "Unlimited free delivery, exclusive partner savings & more with {banner} for U+™",
    zipAltText: "For U Plus logo",
    zipCtaFreeTrial: "Try it FREE for {trial-duration} days",
    zipCtaRegular: "Get started",
    zipExtendedTrial: "plus a {trial-duration}-day free trial",
    noDeliveryZipDescription: "Apologies, for U+™ is not available in your area.",
    selectPlanZipSolicitationLabel: "Enter ZIP Code to get started",
    selectPlanFreeTrialMessage: "Get started by selecting a plan below:",
    selectPlanRegularMessage: "Save extra money on your monthly deliveries!",
    annualPlanDefaultRibbon: "Best Value",
    annualPlanDescription: "Which is equal to just {price} + any applicable taxes.<br /><b>Auto-renews at {renewPrice} unless canceled by renewal date.</b>",
    snapMonthlyPlanDescription: "+Tax, Billed monthly!<br />Requires yearly verification or is automatically cancelled. Discount plan available for up to 24 months",
    snapMonthlyPlanDescriptionSpacing: "+Tax, Billed monthly!<br />Requires yearly verification or is automatically cancelled.<br />Discount plan available for up to 24 months",
    annualPlanCtaFreeTrial: "Start {trial-duration}-day Free Trial",
    annualPlanCtaRegular: "Select",
    annualPlanIsDefaultPlan: "true",
    monthlyPlanDefaultRibbon: "Save 35%",
    monthlyPlanDescription: "+Tax, Billed monthly.<br /> Auto-renews{price}.",
    monthlyPlanDescription2: "+ Any applicable taxes. <b>Auto-renews at {price} unless canceled by renewal date.</b>",
    discountRibbonLabel: "NA",
    paymentNote: "Note: Add or select a credit or debit card for your subscription. Your payment card will not be charged until your free {trial-duration}-day trial has ended.",
    paymentNoteNoTrial: "Note: Your payment card will be charged immediately when confirming sign up for For U+™.",
    trialTaxMessage: "+ Any applicable taxes. Charged after {trial-duration}-day free trial. Auto-renews at {annual-plan-price}{conjunction}{monthly-plan-price} unless canceled before renewal date.",
    taxMessage: "+ any applicable taxes. Auto-renews at {annual-plan-price}{conjunction}{monthly-plan-price}",
    bannerPaymentTermsMsg: "{Banner}"
  },
  subscriptionAuthoringFields: {
    paymentFreeTrialButtonCTA: "Continue",
    paymentButtonCTA: "Continue",
    thankYouPaymentDetailsLabel: "Payment Details",
    thankYouSubscriptionLabel: "Current Subscription Plan ",
    thankYouMsg: "You're all set! Thank you for registering, your for U+™ membership is now active. ",
    changePlanLabel: "Manage Plan",
    changePlanLink: "/content/www/safeway/en/delivery-subscription/manage-delivery-subscription.html",
    updatePaymentLabel: "Update Payment Method",
    updatePaymentLink: "/content/www/safeway/en/account/payment.html",
    showNowButtonLabel: "Shop Now",
    showNowButtonLink: "/",
    selectPlanChangeZipcode: "Change ZIP Code",
    selectPlanTitle: "Choose your plan",
    selectPlanHeading: "Unlimited Delivery is available in",
    freshpassHeading: "Choose a plan",
    freshpassHeading2: "Select a government assisted plan",
    selectPlanTaxes: "(+ tax)",
    selectPlanTaxesSnap: "(+ any applicable taxes)",
    accountTitle: "Set up your account",
    freshPassNoDelivery: "We're sorry, delivery with for U+™ is not available in ",
    freshPassBenefitsTitle: "for U+™ Benefits",
    paymentTitle: "Payment details",
    restrictedZipDescription: "Apologies, for U+™ is not available in your area",
    sisterBannerDescription: "for U+™ is available at our sister store",
    paymentAuthorizeMsgAferPlanOne: ". I consent to and authorize storage of my debit and/or credit card data and authorize charges to such card for purchases, subscription fees after the",
    paymentAuthorizeMsgAferPlanTwo: "-day free trial and for subsequent auto-renewals until I cancel.",
    terms: "terms",
    paymentAuthorizeMsgCurrentPlan:
      ". I consent to and authorize storage of my debit and/or credit card data and authorize charges to such card for current subscription fees and future auto-renewals until I cancel.",
    subscriptionPlan: "subscription plan",
  },
  manage: {
    CURRENT_PLAN_ICON: "ocsp-web-ui/dist/assets/images/ForU+Logo.svg",
    PAYMENT_METHOD: "Payment Method",
    CURRENT_PAYMENT_METHOD: "Payment Method",
    ADD_A_CREDIT_OR_DEBIT_CARD_FOR_YOUR_SUBSCRIPTION: "Add a credit or debit card for your subscription",
    UPDATE_PAYMENT_METHOD: "Update Payment Method",
    ADD_NEW_CARD: "Add New Card",
    EXPIRED: "Expired",
    CONFIRM_CVV: "Confirm CVV",
    CHANGE_PLAN: "Change Plan",
    Cancel_FreshPass: "Cancel for U+™",
    YOUR_PLAN_CAN_NOT_BE_CHANGED_AGAIN_UNTIL_THE_CURRENT_UPDATE_IS_COMPLETE: "Your plan can not be changed again until the current update is complete.",
    MONTHLY: "Monthly",
    ANNUAL: "Annual",
    ANNUAL_PLAN: "Annual Plan",
    MONTHLY_PLAN: "Monthly Plan",
    DISCOUNTED_PLAN_BEGINS_MSG: "Discounted {planType} plan begins</br>{renewalDate}",
    CURRENT_PLAN_BEGINS_MSG: "{planType} plan begins {renewalDate}",
    CURRENT_PLAN_RENEWS_MSG: "Renews {renewalDate}",
    TRIAL: "TRIAL",
    ACTIVE: "ACTIVE",
    SUSPENDED: "Suspended",
    PENDING_ACTIVATION: "PENDING_ACTIVATION",
    PROCESSING: "PROCESSING",
    PENDING_CANCELLATION: "PENDING_CANCELLATION",
    CHANGE_PLAN_CON: "CHANGE_PLAN",
    FREE_TRIAL_ENDS_ON_MSG: "Free trial ends on {currentPlanExpiryDate}",
    FREE_TRIAL: "Free Trial",
    MONTHLY_SUBSCRIBER: "Monthly Subscriber",
    ANNUAL_SUBSCRIBER: "Annual Subscriber",
    CANCELLED: "CANCELLED",
    PLAN_PER_YEAR: "/year",
    PLAN_PER_MONTH: "/month",
    TAX: "(+tax)",
    CURRENT_PLAN_PRICE_DETAILS: "${currentPrice}{pricingDetail} (+tax)",
    AUTO_RENEWS_AT: "Auto-renews at $",
    AUTO_RENEWS_AT_REGULAR_PLAN_PRICE: "Auto-renews at ${regularPlanPrice}{regularPricingDetails}.",
    AUTO_RENEWS_AT_REGULAR_PLAN_PRICE_TAX: "Auto-renews at ${regularPlanPrice}{regularPricingDetails} (+tax).",
    AUTO_RENEWS_AT_CURRENT_FEE_TAX: 'Auto-renews at ${currentFee}{currentPricingDetails} (+tax).',
    AUTO_RENEWS_AT_PENDING_FEE: 'Auto-renews at ${pendingFee}{pendingPricingDetails}.',
    AUTO_RENEWS_AT_PENDING_FEE_FOR_FIRST_YEAR: 'Auto-renews at ${pendingFee}{pendingPricingDetails}.',
    AUTO_RENEWS_AT_PENDING_FEE_TAX: 'Auto-renews at ${pendingFee}{pendingPricingDetails} (+tax).',
    CURRENT_PLAN_UNTIL_EXPIRY_DATE: '${currentPrice}{pricingDetail} until {currentExpiryDate} (+tax)', 
    UNTIL: "until",
    CURRENT_PLAN_ENDS_MSG: "Ends {expiryDate}",
    DISCOUNT_PLAN_BEGINS_MSG: "{discounted} {planType} begins </br> {renewalDate}",
    PLAN_BEGINS_MSG: "{planType} plan begins {renewalDate}",
    VIP_CUSTOMER_SERVICE_PHONE_LINE: "VIP Customer Service Phone Line",
    FRESH_PASS_SUBSCRIBERS_RECEIVE_QUICK_CUSTOMER_SERVICE_FROM_A_DEDICATED_SUPPORT_TEAM: "{banner} for U+™ subscribers receive quick customer service from a dedicated support team.",
    Num_855_767_2545: "855-767-2545",
    SHOP_NOW: "Shop Now",
    DELIVERY_SUBSCRIPTION: "DELIVERY_SUBSCRIPTION",
    FRESHPASS_MANAGE_SUBSCRIPTION: "for U+™ - Manage Subscription",
    NOTIFY_MESSAGE: "notifyMessage",
    F9_B88_F7_E_5_F54_4536_AFC0_8_B080_D189_CDF: "F9B88F7E-5F54-4536-AFC0-8B080D189CDF",
    YOUR_FRESH_PASS_PLAN_IS: "Your {banner} for U+™ plan is currently disabled due to an issue with your payment method. Please update your payment method.",
    YOUR_CURRENT_FRESH_PASS_PLAN: "Your current {banner} for U+™ plan has been <b>cancelled</b> per your request, you can still continue to use {banner} for U+™ until",
    YOUR_CURRENT_FRESH_PASS_PLAN_HAS_BEEN: "Your current {banner} for U+™ plan has been <b>cancelled</b> per your request. Your Free Trial ends on",
    FRESH_PASS_PLAN_WILL_BECOME_EFFECTIVE_AFTER_THE_CURRENT_PLAN_EXPIRES_ON: "for U+™ plan will become effective after the current plan expires on ",
    YOUR_FREE_TRIAL_ENDS_ON: "Your free trial ends on ",
    YOU_LL_BE_AUTOMATICALLY_ENROLLED_INTO_THE: "you’ll be automatically enrolled into the ",
    TRIAL_STATUS_MESSAGE: "Free trial automatically converts to ${fee}{pricingDetail} membership + any applicable taxes unless canceled by {expirationDate}.",
    FRESH_PASS_PLAN_ON: "for U+™ plan on ",
    YOU_CAN_STILL_CONTINUE_TO_USE_FRESH_PASS_UNTIL: "You can still continue to use {banner} for U+™ until ",
    YOUR: "Your $",
    MANAGE_MY_PLAN: "Manage My Plan",
    FRESHPASS: "for U+™",
    NEED_HELP: "Need help?",
    HERE: "here",
    RESTRICTIONS_APPLY_FULL_PROGRAM_TERMS_CONDITIONS: "*Restrictions apply. Refer to {banner} for U+™ Terms & Conditions below.",
    RESTRICTIONS_APPLY_FULL_PROGRAM_TERMS_CONDITIONS_LINK: "*Restrictions apply. Refer to {banner} for U+™ Terms & Conditions",
  },
  confirmation: {
    SAVING_SUMMARY_MODAL: "saving-summary-modal",
    ESTIMATE_ANNUAL_SAVINGS_TERMS: "estimate annual savings terms",
    TERMS_INFO_MODAL_TEXT: "termsInfoModalText",
    SAVINGS_SUMMARY: "Savings Summary",
    FRESH_PASS_ANNUAL_SUBSCRIBERS_COULD_SAVE_UP_TO_425_PER_YEAR: "for U+™ annual subscribers could save up to $425 per year",
    ESTIMATED_ANNUAL_SAVINGS: "Estimated Annual Savings",
    SAVED_AND_COUNTING: " saved, and counting!",
    CONGRATS_YOU_VE_SAVED: "Congrats! You've saved ",
    WITH_FRESH_PASS: " with for U+™",
    WE_HOPE_YOU_RE_ENJOYING_THE_PERKS_AND_THE_SAVINGS: "We hope you're enjoying the perks and the savings!",
    OK_GOT_IT: "Ok, Got It",
    TRIAL: "trial",
    PROCESSING: "processing",
    ANNUAL_PLAN: "Annual Plan",
    ANNUAL: "annual",
    MONTHLY: "monthly",
    YOUR_FRESHPASS_PERKS: "Your {banner} for U+™ Perks",
    FRESHPASS_PERKS: "for U+™ Perks",
    YOUR_FRESH_PASS_BENEFITS: "{banner} for U+™ Benefits",
    ACCOUNT_SUSPENDED: "Account Suspended",
    YOUR_FRESH_PASS_PLAN_IS_CURRENTLY_DISABLED_DUE_TO_AN_ISSUE_WITH_YOUR: "Your {banner} for U+™ plan is currently disabled due to an issue with your payment method. Please update your",
    PAYMENT_METHOD: "payment method.",
    WELCOME_TO_FRESH_PASS_THANKS_FOR_SIGNING_UP_YOUR_PERKS_ARE_ON_THE_WAY_IF: "Welcome to {banner} for U+™! Thanks for signing up, your perks are on the way. If you've redeemed them all, check back soon.",
    DON_T_MISS_OUT_ON_FREE_SAVINGS: "Don't miss out on free savings!",
    FRESH_PASS_ANNUAL_PLAN_SUBSCRIBERS_GET_A_5_CREDIT_EVERY_MONTH: "for U+™ annual plan subscribers get a $5 credit every month",
    AVAILABLE_TO_YOU: "Available to you",
    UPGRADE_NOW: "Upgrade Now",
    ADDED: "Added",
    COUPON_CLIP_SESSION_IS_EXPIRED_RELOADING_THE_PAGE: "Coupon clip session is expired. Reloading the page.",
    IN_STORE: "In-store",
    invalidReasonCode: "Cancellation reason is invalid.",
    cancelDuringBatchProcess: "Subscription is renewing and cannot be cancelled.",
    cancelWithinBufferTime: "Your plan is currently being renewed and cannot be cancelled at this time.",
    serverError: "Internal server error occured.",
    unknownError: "Unknown error. Please contact the support team for resolution.",
    subsPaymentError: "Your enrollment cannot be processed. Please update your payment method and try again.",
    subsDefaultError: "Sorry, we're having technical difficulties and working on fixing them, please check back later.",
    cardUnacceptedError: "Card cannot be accepted. Please confirm card details were entered correctly or continue with another form of payment",
    PARTNERS: "Partners",
    PRTNRS: "prtnrs",
    NO_PRTNRS: "no-prtnrs",
    CONFIRMATION: "confirmation",
    WELCOME: "Welcome",
    ALBERTSONS: "albertsons",
    STARMARKET: "starmarket",
    PAVILIONS: "pavilions",
    ERROR_FETCHING_LOGO_LIST: "error fetching logo list",
    SHAWS: "shaws",
    MASK: "mask",
    FRESHPASSTILEPARSYS: "freshpasstileparsys",
    ERROR_FETCHING_EXPERIENCE_FRAGMENT: "error fetching experience fragment",
    CLASS: "milestone-modal",
    backdrop: "static",
    ariaLabelledBy: "modal milestone dropdown",
    ariaDescribedby: "milestone dropdown",
    timeToShow: "timeToShow",
    ERROR_FETCHING_PARTNERS_DATA: "error fetching partners data",
    notifyMessage: "notifyMessage",
    OFFER_DETAILS: "Offer Details",
    defaultSuspendedErrorMessage: 'Your for U+™ plan is currently disabled due to an issue with your payment method. Please update your',
    defaultSuspendedErrorLinkText: 'payment method'
  },
  notificationModal: {
    promotionExpired: "This promotion has expired",
    viewOffers: "View current offers",
    weAreSorry: "we're sorry, this",
    noLongerAvailable: "is no longer available",
  },
  personalizedSavings: {
    savedSoFar: "saved so far with for U+™",
  },
  savingsSummary: {
    existingDeliveryEngagedText:
      "Based on average delivery orders for existing delivery engaged for U+™ subscribers from 4/1/2021 to 9/23/2021 utilizing non-prime order time slots (delivery fees vary – value based on existing slot utilization of subscribers). Savings calculation also includes $20 savings for first time members on first $75 online purchase, monthly perk values, and product category savings that annual subscribers enjoy. Product savings value is calculated based on existing subscriber data",
    close: "CLOSE",
  },
  termsAndConditions: {
    forMoreInfo: "For more information, see our",
    faq: "FAQ",
    termsNconditions: "Terms and Conditions",
  },
  cancelFreshPass: {
    cancelPlan: "Cancel Plan",
    reasonForCancellationSelect: "Reason for Cancellation (select one):",
    reasonForCancellation: "Reason for Cancellation",
    additionalFeedback: "Additional Feedback",
    noOfCharacters: "No. of characters 0 / 400",
    cancelUserText: "We hate to see you go. Are you sure you want to end your subscription?",
    yesCancelPlan: "Yes, Cancel Plan",
    keepPlan: "No, Keep Plan",
    discountPlanTitle: "Interested in a <br/> one-time discount?",
    discountPlanSecondTitle: "We appreciate you—and want to give you a little gift to show it.",
    discountPlanBtnDesc: "Yes, I'm interested",
    discountPlanCancelBtnDesc: "Continue to cancel",
    benefitsBtnDesc: "Get discounted price",
    benefitsSplOffer: "Special Offer",
    benefitsRetentionPlanAnnual: "Enjoy one year of {banner} for U+™ annual for",
    benefitsRetentionPlanAnnualForSrOnly: "Enjoy one year of {banner} for U+™ annual for new price",
    benefitsTaxInfo: "Which is just {pricingDetailLine2} + any applicable taxes.",
    benefitsRenewMessage:"Which is just {pricingDetailLine2} + any applicable taxes.<br/> Auto-renews at ${price} unless canceled by renewal date.",
    infoMsgForFPCancelRefundNotEligible: "If you cancel today, you keep your {banner} for U+ ™ benefits until ",
    infoMsgForFPCancelRefundEligible: "Because you have not used the {banner} for U+ ™ service and are canceling within 15 days, your subscription fee will be refunded",
    beforeYouGoMessage: 'Before you go, please tell us why you’re not keeping your {banner} for U+™ subscription.'
  },
  cancelFreshPassSuccess: {
    vipCustomerService: "VIP Customer Service Phone Line",
    planType: "for U+™ members receive quick customer service from a dedicated support team.",
    SUSPENDED: "SUSPENDED",
  },
  changePlanSummary: {
    offYourSubscription: "50% off your subscription",
  },
  annualPlan: {
    taxText: "+Tax, Which is equal to $",
    monthText: "/month!",
    renewelText: "Auto-renews at",
    selectAnnual: "Select Annual",
    currentPlan: "Current Plan",
  },
  changePlan: {
    govtAssisted: " government assisted",
    month: "month",
    year: "year",
    trial: "Trial",
    changePlanText: "Change plan",
    planTextOne: " If you select the",
    plan: "plan, ",
    planTextTwo: "it will become effective after the current plan expires on",
  },
  monthlyPlan: {
    taxMonthly: "+Tax, Billed monthly!",
    selectMonthly: "Select Monthly",
    months: "months",
    autoRenew: "Auto-renews.",
  },
  cancelFreshpassSummary: {
    monthlyFreshpass: "Monthly for U+™",
    annualFreshPass: "Annual for U+™",
  },
  paymentModel: {
    API_FAIL_ERROR_MESSAGE: "Sorry, we're having technical difficulties and working on fixing them, please check back later.",
    UNKNOWN_ERROR_MESSAGE: "Unknown error. Please contact the support team for resolution.",
    update: "Update",
  },
  prechurn: {
    retentionDiscountType: 'retentionannual',
    retentionCampaignType: 'retention',
    successStatusMessage: 'Great! You’ll continue to receive for U+™ benefits. Your plan will auto renew at ${pendingFee}{pendingPricingDetail} after your current plan ends.',
    discountPlanBeginsMessage: "Discounted {pendingSubscriptionType} plan begins</br>{renewalDate}"
  },
  partnersBanners: {
    bannerHeading: "Select your preferred store to claim your discount",
    bannerTitle: "Select your store, create an account or sign in. Then subscribe to for U+™ to claim your discount.",
    joinFreshpass: "Join for U+™",
    FAQ: "Frequently Asked Questions",
    termsAndCondition: "Terms & Conditions",
    continue: "Continue",
  },
  partnersLanding: {
    ERROR_DISCOUNT_TITLE: "Sorry, this discount is no longer available.",
    ERROR_DISCOUNT_MESSAGE: "Oops! This offer is either invalid or has expired. Sign up now and start receiving for U+™ benefits today.",
    ERROR_MISSING_BANNERS_TITLE: "Sorry, this page is currently down.",
    ERROR_MISSING_BANNERS_MESSAGE: "Oops! Please check back soon or sign up now and start receiving for U+™ benefits today.",
    DISCOUNT_ERROR: "DISCOUNT_ERROR",
    BANNER_ERROR: "BANNER_ERROR",
  },
  updatePayments: {
    API_FAIL_ERROR_MESSAGE: "Sorry, we're having technical difficulties and working on fixing them, please check back later.",
    paymentUpdatedMsg: "You're  all set! Your payment method has been updated.",
  },
  snapHowItWorks: {
    benefitsTitle: "3 Easy Steps to Sign Up!",
    howItWorksHeading: "Verify your eligibility",
    howItWorksText: "Complete the verification process in your account settings.",
    paymentHeading: "Enter a payment method",
    freeTrailEndText: "When your free trial ends, this payment method will be used for any recurring monthly charges.",
    enjoyBenefits: "Enjoy the benefits!",
    freeDeliveryText: "Get free delivery and all the other exclusive perks.",
  },
  snapBenefits: {
    benefitsTitle: "Your for U+™ benefits",
    termsAndConditions: "Restrictions apply. Refer to for U+™ Terms & Conditions below.",
    dontQualifyText: "Don't qualify? View our other plans.",
    childList: "childList",
  },
}

const freshPassData = {
  title: 'Freshpass',
  name: 'Freshpass',
  displayName: 'Freshpass',
  partnersAppNameCofig: 'Freshpass',
  code: {
    monthlySubsCode: "F9B88F7E-5F54-4536-AFC0-8B080D189CDF"
  },
  urlPath: generateUrlPaths(),
  promotionKeys: {
    discountCode: 'discountCode',
    segment: 'segment',
  },
  imageAssets: {
    subscribedPrimaryLogo: 'https://images.albertsons-media.com/is/image/ABS/freshpass-logo?$lplogo$&defaultImage=Not_Available',
    premiumPerksLogo: 'ocsp-web-ui/dist/assets/images/freshpass_discounts_img.svg',
    couponItemLogo: 'ocsp-web-ui/dist/assets/images/freshpass-logo.svg',
    customerDetailsPrimaryLogo: 'ocsp-web-ui/dist/assets/images/freshpass-logo-v2.svg',
  },
  snackbar: {
    discountAndActive: {
      message: "We’re sorry, this promotion is only available for new for U+™ subscribers.",
      type: "error",
      show: true,
      closeOption: true,
      from: "discountCampaignAndActiveMembership",
      timer: 5000,
      closeOnClick: true,
      theme: "black",
      topVH: "12vh",
      leftVH: "80vw",
    },
  },
  errorCode: {
    DEFAULT_NO_SUBSCRIPTION_ERROR_CODE: 'OSMS-SUBSCRIPTION-00015',
    UNKNOWN_ERROR_CODE: 'OSMS-SUBSCRIPTION-0000',
    INVALID_BANNER_CODE: 'OSMS-SUBSCRIPTION-0001',
    CARD_CANNOT_BE_ACCEPTED_CODE: 'OSMS-SUBSCRIPTION-00022',
    OFFER_NO_LONGER_AVAILABLE_CODE: 'OSMS-SUBSCRIPTION-00047',
    INVALID_REASON_CODE: 'OSMS-SUBSCRIPTION-0009',
    CANCEL_DURING_BATCH_PROCESSING_CODE: "OSMS-SUBSCRIPTION-00013",
    CANCEL_WITHIN_BUFFER_TIME_CODE: "OSMS-SUBSCRIPTION-00014",
    SERVER_ERROR_CODE: "OSMS-SUBSCRIPTION-0007",
    SUBS_PAYMENT_ERROR_CODE: "OSMS-SUBSCRIPTION-00021",
    CARD_UNACCEPTED_ERROR_CODE: "OSMS-SUBSCRIPTION-00022",
  },
  WEBSOURCE: {
    EXPEDIA: 'WEB-EXPEDIA',
  },
  errorMessages: {
    UNKNOWN_ERROR_MESSAGE: 'Unknown error. Please contact the support team for resolution.',
    INVALID_BANNER_MESSAGE: `Freshpass isn't available on {banner} yet, but it's coming soon! Stay tuned!`,
    CARD_CANNOT_BE_ACCEPTED_MESSAGE: 'Card cannot be accepted. Please confirm card details entered correctly or continue with another form of payment.',
    OFFER_NO_LONGER_AVAILABLE_MESSAGE: 'We\'re sorry, this offer is no longer available.',
    DEFAULT_ERROR_MESSAGE: 'Sorry, we\'re having technical difficulties and working on fixing them, please check back later.',
    INVALID_REASON_MESSAGE: "Cancellation reason is invalid.",
    CANCEL_DURING_BATCH_PROCESSING_MESSAGE: "Subscription is renewing and cannot be cancelled.",
    CANCEL_WITHIN_BUFFER_TIME_MESSAGE: "Your plan is currently being renewed and cannot be cancelled at this time.",
    SERVER_ERROR_MESSAGE: "Internal server error occured.",
    UNKNNOWN_ERROR_MESSAGE: "Unknown error. Please contact the support team for resolution.",
    SUBS_PAYMENT_ERROR_MESSAGE: "Your enrollment cannot be processed. Please update your payment method and try again.",
    CARD_UNACCEPTED_ERROR_MESSAGE: "Card cannot be accepted. Please confirm card details were entered correctly or continue with another form of payment",
  },
  freshpassOffers: {
    ltoTitle: "Exclusive Limited Time Offers",
    freshpassLTO: "FRESHPASS LTO",
    freshpassPerks: "FRESHPASS",
  },
  partnersOffers: {
    PARTNER_OFFER_TITLE_V2: "Exclusive partner savings",
    PARTNER_OFFER_SUBTITLE_V2: "Enjoy these benefits with your subscription.",
    PARTNER_OFFER_TITLE: "Partner offers",
    PARTNER_OFFER_SUBTITLE: "Subscribe to FreshPass and get access to these exclusive partnership benefits.",
    VALID_PARTNER_PROGRAM_TYPES: ["freshpass"],
    PARTNER_BANNER_FILTER: "partnerbanner",
  },
  notificationMsg: {
    activeEnrollmentSuccessMsg: 'FreshPass® is active! Perks are on their way.',
    trialEnrollmentSuccessMsg: 'FreshPass® free trial is active! Perks are on their way.',
    canceledMsg: 'Your current FreshPass plan has been cancelled effective immediately per your request.',
    cancelProcessedMsg: '{planType}: Your cancellation request has been processed',
    cancelTrialProcessedMsg: '{isTrial} - {planType}: Your cancellation request has been processed.',
    updatePlanSuccessMsg: 'Your plan has been updated successfully.',
  },
  planCard: {
    selectAction: "Select",
    SNAPAction: "See if I'm eligible",
    plusIcon: "ocsp-web-ui/dist/assets/images/plus.svg",
    moreIcon: "ocsp-web-ui/dist/assets/images/more.svg",
    greenIcon: "ocsp-web-ui/dist/assets/images/green.svg",
    checkmarkCircle: "ocsp-web-ui/dist/assets/images/checkmark-circle.svg",
    trialLabel: "-day free trial",
    creditIcon: "ocsp-web-ui/dist/assets/images/Union.svg",
    annualPlanDescription: "+Tax, Which is equal to just {price}<br/>Auto-renews{renewPrice}.",
    annualDiscountPlanDescription: "+Tax, Auto-renews{renewPrice}",
    monthlyPlanDescription: "+Tax, Auto-renews{price}.",
    SNAPPlanDescription: "For select government assistance programs.<br/> Requires yearly verification.",
    AnnualPlan: "Annual Plan",
    MonthlyPlan: "Monthly Plan",
    SNAP: "SNAP",
    annualCreditLabel: "Monthly credit - a $60 value*",
    snapNotVerified: "Not Verified",
    planDescriptionForSNAPVerified: "+Tax, Requires yearly re-verification or is automatically canceled.",
    monthlyPlanDescriptionForSNAPVerified: "+Tax, Auto-renews at {price}",
    annualOrmonthlySheerLabel: "Your eligibility for government assistance has been verified! Your plan will auto-renew at {price}",
    successColor: "success",
    snapBannerDescription: "Select government assistance programs get 50% off.",
    freshpassBenefitDescription: "Select government assistance programs get all the FreshPass benefits at just",
    campaignTitleText: "FreshPass benefits for half the price",
    planPerYear: "/year or ",
    planPerMonth: "/month.",
    monthlyDescriptionForSNAPVerified: "+Tax, Auto-renews at {price}. Requires yearly re-<br>verification or is automatically canceled",
    monthlyDescriptionForSNAPVerifiedRef: "+Tax, Auto-renews at {price}. Requires yearly re-verification or is automatically canceled",
    AnnualDescriptionForSNAPVerified: "+Tax, Requires yearly re-verification or is automatically<br>canceled.",
  },
  freshpassData: {
    freshpassTitle: "FreshPass",
    freeTrialTitle: "Free Trial",
    freshpassManageTitle: 'Manage your FreshPass® plan',
    annualPlanText: "Annual Plan",
    manageText: "manage",
    snapKey: "snap",
    forTheFirstYearText: "for the first year",
    snapVerifiedActivationMessage: "Your eligibility for government assistance has been verified! Your plan will auto-renew at ${fee}{pricingDetail} (+tax)",
    pendingActivationStatusMessage: "Your plan will auto renew at ${pendingFee}{pendingPricingDetail} after your current plan ends.",
    suspendedGovElibilityText: "Your FreshPass plan is currently suspended. Please re-verify your ",
    govAssistanceElibilityText: "government assistance eligibility.",
    pleaseReverifyEligibilityText: "Please re-verify your eligibility.",
    snapTrialDescription: "+Tax, charged after {trial-duration}-day free trial. Annual re-verification will be required for <br> continued access to discounted subscription price.",
    snapNonTrialDescription: "+Tax. Annual re-verification will be required for continued access to discounted subscription price.",
    fpBenefitsDescription: "Savor next-level savings with your FreshPass subscriber-only benefits. ",
    lifeTimeSavingsText: "Lifetime Freshpass Savings",
    hoursSavedText: "Hours Saved",
    continueSubscription: "Continue FreshPass Subscription",
    noThanksContinueShoping: "No Thanks. Continue Shopping",
    suspendedSecondaryUserPrompt: "Your FreshPass® plan is currently disabled due to an issue with your payment method. Please contact the primary FreshPass® account holder to update the payment method.",
    suspendedSecondaryUserAndGovAssistancePrompt: 'Your FreshPass® plan is currently disabled. Please contact the primary FreshPass® account holder to re-verify their government assistance eligibility.',
    lifeTimeSavingsTooltipDisclaimer: "Total savings are calculated starting on 6/22/2022. If you subscribed to FreshPass™ after this date, your total savings are calculated starting on your subscription date. Total savings calculation is based on discounts to grocery delivery fees and redemption of perks listed on the FreshPass™ subscription page."
  },
  subscribeData: {
    step2HeaderTitle: '',
    redirectedTo: "You will be redirected to",
    shop: "Shop",
    likeToProceed: "you like to proceed?",
    completed: "Completed",
    step: "Step",
    step1: "Step 1",
    step2: "Step 2",
    step3: "Step 3",
    currentStep: "Current step",
    agreeTo: "I agree to the",
    cancel: "Cancel",
    freshPass: "FreshPass",
    zipHeading: "Savor unlimited free delivery* & next-level savings",
    zipAltText: "Freshpass logo",
    zipCtaFreeTrial: "Try it FREE for {trial-duration} days",
    zipCtaRegular: "Get started",
    zipExtendedTrial: "plus a {trial-duration}-day free trial",
    noDeliveryZipDescription: "Apologies, FreshPass is not available in your area.",
    selectPlanZipSolicitationLabel: "Enter ZIP Code to get started",
    selectPlanFreeTrialMessage: "Get started by selecting a plan below:",
    selectPlanRegularMessage: "Save extra money on your monthly deliveries!",
    annualPlanDefaultRibbon: "Best Value",
    annualPlanDescription: "+Tax, Which is equal to just {price}!<br />Auto-renews{renewPrice}.",
    snapMonthlyPlanDescription: "+Tax, Billed monthly!<br />Requires yearly verification or is automatically cancelled. Discount plan available for up to 24 months",
    snapMonthlyPlanDescriptionSpacing: "+Tax, Billed monthly!<br />Requires yearly verification or is automatically cancelled.<br />Discount plan available for up to 24 months",
    annualPlanCtaFreeTrial: "Start {trial-duration}-day Free Trial",
    annualPlanCtaRegular: "Select",
    annualPlanIsDefaultPlan: "true",
    monthlyPlanDefaultRibbon: "Save 35%",
    monthlyPlanDescription: "+Tax, Billed monthly.<br /> Auto-renews{price}.",
    monthlyPlanDescription2: "+Tax, Auto-renews at {price}.",
    discountRibbonLabel: "NA",
    paymentNote: "Note: Add or select a credit or debit card for your subscription. Your payment card will not be charged until your free {trial-duration}-day trial has ended.",
    paymentNoteNoTrial: "Note: Your payment card will be charged immediately when confirming sign up for FreshPass.",
    trialTaxMessage: "+Tax, Charged after {trial-duration}-day free trial. Auto-renews at {annual-plan-price}{conjunction}{monthly-plan-price}.",
    taxMessage: "+Tax, Auto-renews at {annual-plan-price}{conjunction}{monthly-plan-price}.",
    bannerPaymentTermsMsg: "FreshPass",
  },
  subscriptionAuthoringFields: {
    paymentFreeTrialButtonCTA: "Start Free Trial",
    paymentButtonCTA: "Sign Up",
    thankYouPaymentDetailsLabel: "Payment Details",
    thankYouSubscriptionLabel: "Current Subscription Plan ",
    thankYouMsg: "You're all set! Thank you for registering, your FreshPass membership is now active. ",
    changePlanLabel: "Manage Plan",
    changePlanLink: "/content/www/safeway/en/delivery-subscription/manage-delivery-subscription.html",
    updatePaymentLabel: "Update Payment Method",
    updatePaymentLink: "/content/www/safeway/en/account/payment.html",
    showNowButtonLabel: "Shop Now",
    showNowButtonLink: "/",
    selectPlanChangeZipcode: "Change ZIP Code",
    selectPlanTitle: "Choose your plan",
    selectPlanHeading: "Unlimited Delivery is available in",
    freshpassHeading: "Select a plan",
    freshpassHeading2: "Select a government assisted plan",
    selectPlanTaxes: "(+ tax)",
    selectPlanTaxesSnap: "(+ any applicable taxes)",
    accountTitle: "Set up your account",
    freshPassNoDelivery: "We're sorry, delivery with FreshPass is not available in ",
    freshPassBenefitsTitle: "FreshPass Benefits",
    paymentTitle: "Payment details",
    restrictedZipDescription: "Apologies, FreshPass® is not available in your area",
    sisterBannerDescription: "FreshPass is available at our sister store",
    paymentAuthorizeMsgAferPlanOne: ". I consent to and authorize storage of my debit and/or credit card data and authorize charges to such card for purchases, subscription fees after the",
    paymentAuthorizeMsgAferPlanTwo: "-day free trial and for subsequent auto-renewals until I cancel.",
    terms: "terms",
    paymentAuthorizeMsgCurrentPlan:
      ". I consent to and authorize storage of my debit and/or credit card data and authorize charges to such card for current subscription fees and future auto-renewals until I cancel.",
    subscriptionPlan: "Subscription Plan",
  },
  manage: {
    CURRENT_PLAN_ICON: "ocsp-web-ui/dist/assets/images/5-credit-badge-small.svg",
    PAYMENT_METHOD: "Payment Method",
    CURRENT_PAYMENT_METHOD: "Current Payment Method",
    ADD_A_CREDIT_OR_DEBIT_CARD_FOR_YOUR_SUBSCRIPTION: "Add a credit or debit card for your subscription",
    UPDATE_PAYMENT_METHOD: "Update Payment Method",
    ADD_NEW_CARD: "Add New Card",
    EXPIRED: "Expired",
    CONFIRM_CVV: "Confirm CVV",
    CHANGE_PLAN: "Change Plan",
    Cancel_FreshPass: "Cancel FreshPass",
    YOUR_PLAN_CAN_NOT_BE_CHANGED_AGAIN_UNTIL_THE_CURRENT_UPDATE_IS_COMPLETE: "Your plan can not be changed again until the current update is complete.",
    MONTHLY: "Monthly",
    ANNUAL: "Annual",
    ANNUAL_PLAN: "Annual Plan",
    MONTHLY_PLAN: "Monthly Plan",
    DISCOUNTED_PLAN_BEGINS_MSG: "Discounted {planType} plan begins</br>{renewalDate}",
    CURRENT_PLAN_BEGINS_MSG: "{planType} plan begins {renewalDate}",
    CURRENT_PLAN_RENEWS_MSG: "Renews {renewalDate}",
    TRIAL: "TRIAL",
    ACTIVE: "ACTIVE",
    SUSPENDED: "Suspended",
    PENDING_ACTIVATION: "PENDING_ACTIVATION",
    PROCESSING: "PROCESSING",
    PENDING_CANCELLATION: "PENDING_CANCELLATION",
    CHANGE_PLAN_CON: "CHANGE_PLAN",
    FREE_TRIAL_ENDS_ON_MSG: "Free trial ends on {currentPlanExpiryDate}",
    FREE_TRIAL: "Free Trial",
    MONTHLY_SUBSCRIBER: "Monthly Subscriber",
    ANNUAL_SUBSCRIBER: "Annual Subscriber",
    CANCELLED: "CANCELLED",
    PLAN_PER_YEAR: "/year",
    PLAN_PER_MONTH: "/month",
    TAX: "(+tax)",
    CURRENT_PLAN_PRICE_DETAILS: "${currentPrice}{pricingDetail} (+tax)",
    AUTO_RENEWS_AT: "Auto-renews at $",
    AUTO_RENEWS_AT_REGULAR_PLAN_PRICE: "Auto-renews at ${regularPlanPrice}{regularPricingDetails}.",
    AUTO_RENEWS_AT_REGULAR_PLAN_PRICE_TAX: "Auto-renews at ${regularPlanPrice}{regularPricingDetails} (+tax).",
    AUTO_RENEWS_AT_CURRENT_FEE_TAX: 'Auto-renews at ${currentFee}{currentPricingDetails} (+tax).',
    AUTO_RENEWS_AT_PENDING_FEE: 'Auto-renews at ${pendingFee}{pendingPricingDetails}.',
    AUTO_RENEWS_AT_PENDING_FEE_FOR_FIRST_YEAR: 'Auto-renews at ${pendingFee}{pendingPricingDetails}.',
    AUTO_RENEWS_AT_PENDING_FEE_TAX: 'Auto-renews at ${pendingFee}{pendingPricingDetails} (+tax).',
    CURRENT_PLAN_UNTIL_EXPIRY_DATE: '${currentPrice}{pricingDetail} until {currentExpiryDate} (+tax)',
    UNTIL: "until",
    CURRENT_PLAN_ENDS_MSG: "Ends {expiryDate}",
    DISCOUNT_PLAN_BEGINS_MSG: "{discounted} {planType} begins </br> {renewalDate}",
    PLAN_BEGINS_MSG: "{planType} plan begins {renewalDate}",
    VIP_CUSTOMER_SERVICE_PHONE_LINE: "VIP Customer Service Phone Line",
    FRESH_PASS_SUBSCRIBERS_RECEIVE_QUICK_CUSTOMER_SERVICE_FROM_A_DEDICATED_SUPPORT_TEAM: "FreshPass subscribers receive quick customer service from a dedicated support team.",
    Num_855_767_2545: "855-767-2545",
    SHOP_NOW: "Shop Now",
    DELIVERY_SUBSCRIPTION: "DELIVERY_SUBSCRIPTION",
    NOTIFY_MESSAGE: "notifyMessage",
    F9_B88_F7_E_5_F54_4536_AFC0_8_B080_D189_CDF: "F9B88F7E-5F54-4536-AFC0-8B080D189CDF",
    YOUR_FRESH_PASS_PLAN_IS: "Your FreshPass plan is currently disabled due to an issue with your payment method. Please update your payment method.",
    YOUR_CURRENT_FRESH_PASS_PLAN: "Your current FreshPass plan has been <b>cancelled</b> per your request, you can still continue to use FreshPass until",
    YOUR_CURRENT_FRESH_PASS_PLAN_HAS_BEEN: "Your current FreshPass plan has been <b>cancelled</b> per your request. Your Free Trial ends on",
    FRESH_PASS_PLAN_WILL_BECOME_EFFECTIVE_AFTER_THE_CURRENT_PLAN_EXPIRES_ON: "FreshPass plan will become effective after the current plan expires on ",
    YOUR_FREE_TRIAL_ENDS_ON: "Your free trial ends on ",
    YOU_LL_BE_AUTOMATICALLY_ENROLLED_INTO_THE: "you’ll be automatically enrolled into the ",
    TRIAL_STATUS_MESSAGE: "Your free trial ends on {expirationDate}, you’ll be automatically enrolled into the <b>{expirationPlanType}</b> FreshPass plan on {renewalDate}.",
    FRESH_PASS_PLAN_ON: "FreshPass plan on ",
    YOU_CAN_STILL_CONTINUE_TO_USE_FRESH_PASS_UNTIL: "You can still continue to use FreshPass until ",
    YOUR: "Your $",
    MANAGE_MY_PLAN: "Manage My Plan",
    FRESHPASS: "FreshPass<sup>®</sup>",
    NEED_HELP: "Need Help?",
    HERE: "here",
    RESTRICTIONS_APPLY_FULL_PROGRAM_TERMS_CONDITIONS: "Restrictions apply. Refer to Full program terms & conditions below.",
    RESTRICTIONS_APPLY_FULL_PROGRAM_TERMS_CONDITIONS_LINK: "Restrictions apply. Refer to Full program terms & conditions",
  },
  confirmation: {
    SAVING_SUMMARY_MODAL: "saving-summary-modal",
    ESTIMATE_ANNUAL_SAVINGS_TERMS: "estimate annual savings terms",
    TERMS_INFO_MODAL_TEXT: "termsInfoModalText",
    SAVINGS_SUMMARY: "Savings Summary",
    FRESH_PASS_ANNUAL_SUBSCRIBERS_COULD_SAVE_UP_TO_425_PER_YEAR: "FreshPass annual subscribers could save up to $425 per year",
    ESTIMATED_ANNUAL_SAVINGS: "Estimated Annual Savings",
    SAVED_AND_COUNTING: " saved, and counting!",
    CONGRATS_YOU_VE_SAVED: "Congrats! You've saved ",
    WITH_FRESH_PASS: " with FreshPass",
    WE_HOPE_YOU_RE_ENJOYING_THE_PERKS_AND_THE_SAVINGS: "We hope you're enjoying the perks and the savings!",
    OK_GOT_IT: "Ok, Got It",
    TRIAL: "trial",
    PROCESSING: "processing",
    ANNUAL_PLAN: "Annual Plan",
    ANNUAL: "annual",
    MONTHLY: "monthly",
    YOUR_FRESHPASS_PERKS: "Your FreshPass Perks",
    FRESHPASS_PERKS: "FreshPass Perks",
    YOUR_FRESH_PASS_BENEFITS: "Your FreshPass Benefits",
    ACCOUNT_SUSPENDED: "Account Suspended",
    YOUR_FRESH_PASS_PLAN_IS_CURRENTLY_DISABLED_DUE_TO_AN_ISSUE_WITH_YOUR: "Your FreshPass plan is currently disabled due to an issue with your payment method. Please update your",
    PAYMENT_METHOD: "payment method.",
    WELCOME_TO_FRESH_PASS_THANKS_FOR_SIGNING_UP_YOUR_PERKS_ARE_ON_THE_WAY_IF: "Welcome to FreshPass! Thanks for signing up, your perks are on the way. If you've redeemed them all, check back soon.",
    DON_T_MISS_OUT_ON_FREE_SAVINGS: "Don't miss out on free savings!",
    FRESH_PASS_ANNUAL_PLAN_SUBSCRIBERS_GET_A_5_CREDIT_EVERY_MONTH: "FreshPass annual plan subscribers get a $5 credit every month",
    AVAILABLE_TO_YOU: "Available to you",
    UPGRADE_NOW: "Upgrade Now",
    ADDED: "Added",
    COUPON_CLIP_SESSION_IS_EXPIRED_RELOADING_THE_PAGE: "Coupon clip session is expired. Reloading the page.",
    IN_STORE: "In-store",
    invalidReasonCode: "Cancellation reason is invalid.",
    cancelDuringBatchProcess: "Subscription is renewing and cannot be cancelled.",
    cancelWithinBufferTime: "Your plan is currently being renewed and cannot be cancelled at this time.",

    serverError: "Internal server error occured.",
    unknownError: "Unknown error. Please contact the support team for resolution.",
    subsPaymentError: "Your enrollment cannot be processed. Please update your payment method and try again.",
    subsDefaultError: "Sorry, we're having technical difficulties and working on fixing them, please check back later.",
    cardUnacceptedError: "Card cannot be accepted. Please confirm card details were entered correctly or continue with another form of payment",
    PARTNERS: "Partners",
    FRESHPASS_SUBSCRIPTION_CONFIRMATION: "Freshpass - Subscription Confirmation",
    PRTNRS: "prtnrs",
    NO_PRTNRS: "no-prtnrs",
    CONFIRMATION: "confirmation",
    WELCOME: "Welcome",
    ALBERTSONS: "albertsons",
    STARMARKET: "starmarket",
    PAVILIONS: "pavilions",
    ERROR_FETCHING_LOGO_LIST: "error fetching logo list",
    SHAWS: "shaws",
    MASK: "mask",
    FRESHPASSTILEPARSYS: "freshpasstileparsys",
    ERROR_FETCHING_EXPERIENCE_FRAGMENT: "error fetching experience fragment",
    CLASS: "milestone-modal",
    backdrop: "static",
    ariaLabelledBy: "modal milestone dropdown",
    ariaDescribedby: "milestone dropdown",
    timeToShow: "timeToShow",
    ERROR_FETCHING_PARTNERS_DATA: "error fetching partners data",
    notifyMessage: "notifyMessage",
    OFFER_DETAILS: "Offer Details",
    defaultSuspendedErrorMessage: 'Your FreshPass plan is currently disabled due to an issue with your payment method. Please update your',
    defaultSuspendedErrorLinkText: 'payment method'

  },
  notificationModal: {
    promotionExpired: "This promotion has expired",
    viewOffers: "View current offers",
    weAreSorry: "we're sorry, this",
    noLongerAvailable: "is no longer available",
  },
  personalizedSavings: {
    savedSoFar: "saved so far with FreshPass",
  },
  savingsSummary: {
    existingDeliveryEngagedText:
      "Based on average delivery orders for existing delivery engaged FreshPass subscribers from 4/1/2021 to 9/23/2021 utilizing non-prime order time slots (delivery fees vary – value based on existing slot utilization of subscribers). Savings calculation also includes $20 savings for first time members on first $75 online purchase, monthly perk values, and product category savings that annual subscribers enjoy. Product savings value is calculated based on existing subscriber data",
    close: "CLOSE",
  },
  termsAndConditions: {
    forMoreInfo: "For more information, see our",
    faq: "FAQ",
    termsNconditions: "Terms and Conditions",
},
  cancelFreshPass: {
    cancelPlan: "Cancel Plan",
    reasonForCancellationSelect: "Reason for Cancellation (select one):",
    reasonForCancellation: "Reason for Cancellation",
    additionalFeedback: "Additional Feedback",
    noOfCharacters: "No. of characters 0 / 400",
    cancelUserText: "We hate to see you go. Are you sure you want to end your subscription?",
    yesCancelPlan: "Yes, Cancel Plan",
    keepPlan: "No, Keep Plan",
    discountPlanTitle: "Interested in a one-time discount?",
    discountPlanSecondTitle: "We appreciate you—and want to give you a little gift to show it.",
    discountPlanBtnDesc: "Yes, I'm interested",
    discountPlanCancelBtnDesc: "Continue to cancel",
    benefitsBtnDesc: "Get discounted price",
    benefitsSplOffer: "Special Offer",
    benefitsRetentionPlanAnnual: "Enjoy one year of FreshPass annual for",
    benefitsRetentionPlanAnnualForSrOnly: "Enjoy one year of FreshPass annual for new price",
    benefitsTaxInfo: "+Tax,",
    benefitsRenewMessage:"+Tax, Auto-renews {price}",
    infoMsgForFPCancelRefundNotEligible:"If you cancel today, you keep your FreshPass benefits until ",
    infoMsgForFPCancelRefundEligible: "Because you have not used the FreshPass service and are canceling within 15 days, your subscription fee will be refunded",
    beforeYouGoMessage: 'Before you go, please tell us why you’re not keeping your FreshPass subscription.'
  },
  changePlanSummary: {
    offYourSubscription: "50% off your subscription",
  },
  annualPlan: {
    taxText: "+Tax, Which is equal to $",
    monthText: "/month!",
    renewelText: "Auto-renews at",
    selectAnnual: "Select Annual",
    currentPlan: "Current Plan",
  },
  changePlan: {
    govtAssisted: " government assisted",
    month: "month",
    year: "year",
    trial: "Trial",
    changePlanText: "Change plan",
    planTextOne: " If you select the",
    plan: "plan, ",
    planTextTwo: "it will become effective after the current plan expires on",
  },
  monthlyPlan: {
    taxMonthly: "+Tax, Billed monthly!",
    selectMonthly: "Select Monthly",
    months: "months",
    autoRenew: "Auto-renews.",
  },
  cancelFreshpassSummary: {
    monthlyFreshpass: "Monthly FreshPass",
    annualFreshPass: "Annual FreshPass",
  },
  paymentModel: {
    API_FAIL_ERROR_MESSAGE: "Sorry, we're having technical difficulties and working on fixing them, please check back later.",
    UNKNOWN_ERROR_MESSAGE: "Unknown error. Please contact the support team for resolution.",
    update: "Update",
  },
  prechurn: {
    retentionDiscountType: 'retentionannual',
    retentionCampaignType: 'retention',
    successStatusMessage: 'Great! You’ll continue to receive FreshPass benefits. Your plan will auto renew at ${pendingFee}{pendingPricingDetail} after your current plan ends.',
    discountPlanBeginsMessage: "Discounted {pendingSubscriptionType} plan begins</br>{renewalDate}"
  },
  partnersBanners: {
    bannerHeading: "Select your preferred store to claim your discount",
    bannerTitle: "Select your store, create an account or sign in. Then subscribe to FreshPass to claim your discount.",
    joinFreshpass: "Join FreshPass",
    FAQ: "Frequently Asked Questions",
    termsAndCondition: "Terms & Conditions",
    continue: "Continue",
  },
  partnersLanding: {
    ERROR_DISCOUNT_TITLE: "Sorry, this discount is no longer available.",
    ERROR_DISCOUNT_MESSAGE: "Oops! This offer is either invalid or has expired. Sign up now and start receiving FreshPass benefits today.",
    ERROR_MISSING_BANNERS_TITLE: "Sorry, this page is currently down.",
    ERROR_MISSING_BANNERS_MESSAGE: "Oops! Please check back soon or sign up now and start receiving FreshPass benefits today.",
    DISCOUNT_ERROR: "DISCOUNT_ERROR",
    BANNER_ERROR: "BANNER_ERROR",
  },
  updatePayments: {
    API_FAIL_ERROR_MESSAGE: "Sorry, we're having technical difficulties and working on fixing them, please check back later.",
    paymentUpdatedMsg: "You're  all set! Your payment method has been updated.",
  },
  snapHowItWorks: {
    benefitsTitle: "3 Easy Steps to Sign Up!",
    howItWorksHeading: "Verify your eligibility",
    howItWorksText: "Complete the verification process in your account settings.",
    paymentHeading: "Enter a payment method",
    freeTrailEndText: "When your free trial ends, this payment method will be used for any recurring monthly charges.",
    enjoyBenefits: "Enjoy the benefits!",
    freeDeliveryText: "Get free delivery and all the other exclusive perks.",
  },
  snapBenefits: {
    benefitsTitle: "Your FreshPass benefits",
    termsAndConditions: "Restrictions apply. Refer to FreshPass Terms & Conditions below.",
    dontQualifyText: "Don't qualify? View our other plans.",
    childList: "childList",
  },
}

export const properties = {
  oktaRedirectUri: "/osar/msi",
  oktaRedirectUriImplict: "/osar/msi/implicit/callback",
  oktaRedirectUriConfirmation: "/erums/order/confirmation/implicit/callback",
  erumsRedirectCookieName: "erums-from-uri",
  storeResolverZipcodeToShoppingEndPoint: "/abs/qapub/xapi/storeresolver/zipcodetoshopping",
  clientBannerHeader: "banner",
  headerStoreId: "",
  headerFulfillment: "instore",
  storeId: "",
  SVG: '.svg',
  cookiesOneTrustConsentEle: "onetrust-consent-sdk",
  tooltips: {
    personalizedSavings: {
      title: "FreshPass™ Savings",
      text: "Total savings are calculated starting on 6/22/2022. If you subscribed to for U+™ after this date, your total savings are calculated starting on your subscription date. Total savings calculation is based on discounts to grocery delivery fees and redemption of perks listed on the for U+™ subscription page.",
    },
    estimatedTotal: {
      title: "Estimated Total",
      text:
        "<b>You will pay the prices, fees, and other charges, and receive the promotions, offers, discounts, and savings applicable to your order on the date of scheduled delivery/pickup.</b>" +
        " The estimated total includes applicable delivery fees but does not include coupons clipped, buy one get one deals, club card, " +
        "Schedule & Save and promo code discounts, certain applicable taxes, bottle/can deposit, bag/other fees unless otherwise noted, the cost of substituted items, " +
        "or reductions from out of stock items removed from your order. The final amount shown on your receipt at the time of delivery or pickup will reflect these adjustments. " +
        "A hold will be placed on your debit/ credit card for this estimated total and will reduce the amount available to spend from your account. " +
        "Your bank may take up to 5 business days after delivery/pickup to release the hold and display your final charge.",
      textV1: "",
      warning: false,
    },
    estimatedSubTotal: {
      title: "Estimated SubTotal",
      text:
        "<b>You will pay the prices, fees, and other charges, and receive the promotions, offers, discounts, and savings applicable to your order on the date of scheduled delivery/pickup.</b>" +
        " The estimated sub total does not include coupons clipped, buy one get one deals, club card, Schedule & Save and promo code discounts, " +
        "delivery fees if applicable, certain applicable taxes, bottle/can deposit, bag/other fees unless otherwise noted, " +
        "the cost of substituted items, or reductions from out of stock items removed from your order.",
      textV1: "",
      warning: false,
    },
    oneTimePurchaseItems: {
      title: "One-Time Purchase Items",
      text: '<b>Use "Add Items" to include one-time purchase items in an already scheduled delivery/pickup order. One-time purchase items will not be added to future Schedule & Save orders.',
      textV1: "",
      warning: false,
    },
    deliveryFee: {
      title: "What is a Delivery Fee?",
      text: "<div>" + ' <div class="verticalSpace-5"></div>' + "A delivery fee helps us operate our fleet of trucks that transports your order from our facilities to your address." + "</div>",
      warning: false,
    },
    udcInfo: {
      title: "Unlimited Delivery Club",
      text:
        '<p class="mb-2">Save money when you signup for unlimited deliveries for one low fee!<p>' +
        "<br/>" +
        "Sign up for one of our Unlimited Delivery Club Service plans and we will waive the delivery fee on any order over $30 for the selected duration. You can choose a monthly plan for $14.99 or an annual plan for $99. (The annual plan averages out to just $8.25/month.)",
      warning: false,
    },
    udcTerms: {
      title: "Unlimited Delivery Club Terms",
      text:
        '<p class="mb-2">You agree to consent and authorize storage of your debit and/or credit card data' +
        "and authorize charges to such card for subscription fees after the 30-day free trial and" +
        "for subsequent auto-renewals until you cancel." +
        "</p>",
      warning: false,
    },
    udcTermsFreeTrial: {
      title: "Unlimited Delivery Club Terms",
      text: "I consent to and authorize storage of my debit and/or credit card data and authorize charges to such card for subscription fees after the 30-day free trial and for subsequent auto-renewals until I cancel.",
      warning: false,
    },
    udcTermsNonFreeTrial: {
      title: "Unlimited Delivery Club Terms",
      text: "I consent to and authorize storage of my debit and/or credit card data and authorize charges to such card for current subscription fees and future auto-renewals until I cancel.",
      warning: false,
    },
    estimatedTax: {
      title: "Estimated Taxes & Fees",
      text: "The Estimated Taxes and Fees shown include your delivery fee (if applicable), any applicable taxes, bottle/can deposits, and bag/other fees. Your final receipt may reflect adjustments to these taxes, deposits and fees due to changes in your order, including but not limited to the availability or expiration of promotions, offers, discounts, and savings, the final cost of items sold by weight, item substitutions, or out of stock items removed from your order.",
    },
  },
  bannerConfiguration: {
    tomthumb: {
      banner: "Tom Thumb",
      loyaltyPgmName: "Reward Card",
      promoDescription: "Reward Card Price",
      estimatedSavings: "Est. Reward Card Savings",
      adaEstimatedSavings: "Estimated Reward Card Savings",
      logoUrls: {
        color: "TomThumb_RGB.svg",
        white: "TomThumb_W.svg",
      },
    },
    albertsons: {
      banner: "Albertsons",
      loyaltyPgmName: "On Sale",
      promoDescription: "On Sale Now",
      estimatedSavings: "Est. On Sale Savings",
      adaEstimatedSavings: "Estimated On Sale Savings",
      logoUrls: {
        color: "Albertsons_RGB.svg",
        white: "Albertsons_W.svg",
      },
    },
    vons: {
      banner: "Vons",
      loyaltyPgmName: "Club Card",
      promoDescription: "Club Card Price",
      estimatedSavings: "Est. Club Card Savings",
      adaEstimatedSavings: "Estimated Club Card Savings",
      logoUrls: {
        color: "Vons_RGB.svg",
        white: "Vons_W.svg",
      },
    },
    safeway: {
      banner: "Safeway",
      loyaltyPgmName: "Club Card",
      promoDescription: "Club Card Price",
      estimatedSavings: "Est. Club Card Savings",
      adaEstimatedSavings: "Estimated Club Card Savings",
      logoUrls: {
        color: "Safeway_RGB.svg",
        white: "Safeway_W.svg",
      },
    },
    randalls: {
      banner: "Randalls",
      loyaltyPgmName: "Remarkable Card",
      promoDescription: "Remarkable Card Price",
      estimatedSavings: "Est. Remarkable Card Savings",
      adaEstimatedSavings: "Estimated Remarkable Card Savings",
      logoUrls: {
        color: "Randalls_RGB.svg",
        white: "Randalls_W.svg",
      },
    },
    pavilions: {
      banner: "Pavilions",
      loyaltyPgmName: "Club Price",
      promoDescription: "Club Price",
      estimatedSavings: "Est. Club Price Savings",
      adaEstimatedSavings: "Estimated Club Price Savings",
      logoUrls: {
        color: "Pavilions_RGB.svg",
        white: "Pavilions_W.svg",
      },
    },
    jewelosco: {
      banner: "Jewel-Osco",
      loyaltyPgmName: "Sale Price",
      promoDescription: "Sale Price",
      estimatedSavings: "Est. Sale Price Savings",
      adaEstimatedSavings: "Estimated Sale Price Savings",
      logoUrls: {
        color: "JewelOsco_Vert_Oval_RGB.svg",
        white: "JewelOsco_Vert_Oval_W.svg",
      },
    },
    carrsqc: {
      banner: "Carrs",
      loyaltyPgmName: "Club Card",
      promoDescription: "Club Card Price",
      estimatedSavings: "Est. Club Card Savings",
      adaEstimatedSavings: "Estimated Club Card Savings",
      logoUrls: {
        color: "Carrs_RGB.svg",
        white: "Carrs_W.svg",
      },
    },
    acmemarkets: {
      banner: "Acme",
      loyaltyPgmName: "Sale Price",
      promoDescription: "Sale Price",
      estimatedSavings: "Est. Sale Price Savings",
      logoUrls: {
        color: "Acme_RGB.svg",
        white: "Acme_W.svg",
      },
    },
    shaws: {
      banner: "Shaws",
      loyaltyPgmName: "Sale Price",
      promoDescription: "Sale Price",
      estimatedSavings: "Est. Sale Price Savings",
      logoUrls: {
        color: "Shaws_RGB.svg",
        white: "Shaws_W.svg",
      },
    },
    starmarket: {
      banner: "Star Market",
      loyaltyPgmName: "Sale Price",
      promoDescription: "Sale Price",
      estimatedSavings: "Est. Sale Price Savings",
      logoUrls: {
        color: "StarMarket_RGB.svg",
        white: "StarMarket_W.svg",
      },
    },
    kingsfoodmarkets: {
      banner: "Kings",
      loyaltyPgmName: "Sale Price",
      promoDescription: "Sale Price",
      estimatedSavings: "Est. Sale Price Savings",
      logoUrls: {
        color: "Kingsfoodmarkets_RGB.svg",
        white: "Kingsfoodmarkets_W.svg",
      },
    },
    balduccis: {
      banner: "Balduccis",
      loyaltyPgmName: "Sale Price",
      promoDescription: "Sale Price",
      estimatedSavings: "Est. Sale Price Savings",
      logoUrls: {
        color: "Balduccis_RGB.svg",
        white: "Balduccis_W.svg",
      },
    },
    andronicos: {
      banner: 'Andronicos',
    },
    haggen: {
      banner: 'Haggen',
    },
    shopamigos: {
      banner: 'ShopAmigos',
    },
    shopmarketstreet: {
      banner: 'ShopMarketStreet',
    },
    shopunitedsupermarkets: {
      banner: 'ShopUnitedSupermarkets',
    },
    shopalbertsonsmarket: {
      banner: 'ShopAlbertsonsMarket',
    },
  },
  PromoTypeDescription: {
    BOGO: "Buy 1 Get 1 Free",
    B2G1: "Buy Two Get 1 Free",
  },
  timer: {
    lastLoginAllowedTime: 45,
  },
  summaryTexts: {
    sumamrySnapText: "SNAP Eligible Item Total",
    sumamryNonSnapText: "Non-SNAP Eligible Item Total",
  },
  bannerMapper: {
    safeway: "SAFEWAY",
    vons: "VONS",
    randalls: "RANDALLS",
    tomthumb: "TOMTHUMB",
    acmemarkets: "ACMEMARKETS",
    carrsqc: "CARRSQC",
    jewelosco: "JEWELOSCO",
    albertsons: "ALBERTSONS",
    starmarket: "STARMARKET",
    shaws: "SHAWS",
    pavilions: "PAVILIONS",
    kingsfoodmarkets: "KINGSFOODMARKETS",
    balduccis: "BALDUCCIS",
  },
  bannerLogoMapper: {
    safeway: "/content/dam/logos/Safeway_RGB.svg",
    vons: "/content/dam/logos/Vons_RGB.svg",
    randalls: "/content/dam/safeway/images/logos/Randalls_RGB.svg",
    tomthumb: "/content/dam/safeway/images/logos/TomThumb_RGB.svg",
    acmemarkets: "/content/dam/logos/Acme_RGB.svg",
    carrsqc: "/content/dam/logos/Carrs_RGB.svg",
    jewelosco: "/content/dam/safeway/images/logos/JewelOsco_Vert_Oval_RGB.svg",
    albertsons: "/content/dam/safeway/images/logos/Albertsons_RGB.svg",
    starmarket: "/content/dam/logos/StarMarket_RGB.svg",
    shaws: "/content/dam/logos/Shaws_RGB.svg",
    pavilions: "/content/dam/logos/Pavilions_RGB.svg",
    kingsfoodmarkets: "/content/dam/logos/Kingsfoodmarkets_RGB.svg",
    balduccis: "/content/dam/logos/Balduccis_RGB.svg",
    shopamigos: "https://images.albertsons-media.com/is/image/ABSStage/nav-shopamigos-logo",
    shopmarketstreet: "https://images.albertsons-media.com/is/image/ABSStage/nav-shopmarketstreet-logo",
    shopunitedsupermarkets: "https://images.albertsons-media.com/is/image/ABSStage/nav-shopunitedsupermarkets-logo",
    shopalbertsonsmarket: "https://images.albertsons-media.com/is/image/ABSStage/nav-shopalbertsonsmarket-logo",

  },
  invalidReasonCode: "Cancellation reason is invalid.",
  cancelDuringBatchProcess: "Subscription is renewing and cannot be cancelled.",
  cancelWithinBufferTime: "Your plan is currently being renewed and cannot be cancelled at this time.",
  serverError: "Internal server error occured.",
  cardRefundError: "We're sorry, we were unable to cancel your subscription. Please call our Customer Support team at {NUM} so we can help resolve it.",
  unknownError: "Unknown error. Please contact the support team for resolution.",
  subsPaymentError: "Your enrollment cannot be processed. Please update your payment method and try again.",
  subsDefaultError: "Sorry, we're having technical difficulties and working on fixing them, please check back later.",
  cardUnacceptedError: "Card cannot be accepted. Please confirm card details were entered correctly or continue with another form of payment",
  freshpassBenefits: {
    freshpass_tile_item__854420891: {
      fpImage: "ocsp-web-ui/dist/assets/images/greenBenefitsTruck.svg",
      rteTitle: '<div style="text-align: left;">Unlimited Free Delivery on orders over $30</div>\r\n',
      rule: "static",
      infoIcon: "false",
      textIsRich: "true",
      tileImageAltText: "benefitsTruck",
    },
    freshpass_tile_item__1519499692: {
      fpImage: "ocsp-web-ui/dist/assets/images/monthlycredit.svg",
      rteTitle: "$5 Monthly Credit for Annual Subscribers",
      rule: "static",
      infoIcon: "false",
      textIsRich: "true",
      tileImageAltText: "$5 monthly credit for annual subscribers",
    },
    freshpass_tile_item_: {
      fpImage: "ocsp-web-ui/dist/assets/images/save20.svg",
      rteTitle: "Save $20 Off Your First Online Order Over $75",
      rule: "static",
      infoIcon: "false",
      textIsRich: "true",
      tileImageAltText: "save 20 image",
    },
    freshpass_tile_item__797202485: {
      fpImage: "ocsp-web-ui/dist/assets/images/2xpoints.svg",
      rteTitle: '<div style="text-align: left;">Earn 2X Reward Points on Our Exclusive Brands</div>\r\n',
      rule: "static",
      infoIcon: "false",
      textIsRich: "true",
      tileImageAltText: "Earn 2X Reward Points on Our Exclusive Brands",
    },
    freshpass_tile_item__566169671: {
      fpImage: "ocsp-web-ui/dist/assets/images/organic.svg",
      rteTitle: "Save 5% on O Organics<sup>®</sup> and Open Nature<sup>®</sup>",
      rule: "static",
      infoIcon: "false",
      textIsRich: "true",
      tileImageAltText: "Save 5% on O Organics and Open Nature",
    },
    freshpass_tile_item__1650940289: {
      fpImage: "ocsp-web-ui/dist/assets/images/pet.svg",
      rteTitle: "Save 5% on Signature Pet Care<sup>®</sup>",
      rule: "static",
      infoIcon: "false",
      textIsRich: "true",
      tileImageAltText: "Save 5% on Signature Pet Care",
    },
    freshpass_tile_item__1951713976: {
      fpImage: "ocsp-web-ui/dist/assets/images/rewardsDontExpire.svg",
      rteTitle: "Rewards Don't Expire",
      rule: "static",
      infoIcon: "false",
      textIsRich: "true",
      tileImageAltText: "Rewards don't expire",
    },
    freshpass_tile_item__1555375445: {
      fpImage: "ocsp-web-ui/dist/assets/images/starbucksCupArt.svg",
      rteTitle: "Monthly Exclusive Starbucks<sup>®</sup> Perks",
      rule: "static",
      infoIcon: "false",
      textIsRich: "true",
      tileImageAltText: "starbucks cup",
    },
    freshpass_tile_item__1944760550: {
      fpImage: "ocsp-web-ui/dist/assets/images/vipPhoneLine.svg",
      rteTitle: "VIP Phone Line",
      rule: "static",
      infoIcon: "false",
      textIsRich: "true",
      tileImageAltText: "vip phone line",
    },
  },
  benefits_DUG5: {
    acme: {
      freshpass_tile_item__1: {
        fpImage: "ocsp-web-ui/dist/assets/images/5OffDUG.svg",
        rteTitle: "5% off Drive Up & Go™ orders** Ends 8/15",
        rule: "static",
        infoIcon: "false",
        textIsRich: "true",
        tileImageAltText: "drive up and go image",
      },
    },
    jewelosco: {
      freshpass_tile_item__2: {
        fpImage: "ocsp-web-ui/dist/assets/images/5OffDUG.svg",
        rteTitle: "5% off Drive Up & Go™ orders** Ends 6/15",
        rule: "static",
        infoIcon: "false",
        textIsRich: "true",
        tileImageAltText: "drive up and go image",
      },
    },
  },
  featureFlags,
  freshpassRestrictedZipcodes: ["86040"],
  programType: {
    forUPlus: forUPlusData,
    freshpass: freshPassData,
  }
};

